import { Label } from "@admin/components/atoms/Input/Label";
import { LocationLicensesDto, Module } from "@enos-monorepo/lib";
import { Dispatch, SetStateAction } from "react";

interface Props {
  modules: Module[];
  setSelectedModule: Dispatch<SetStateAction<Module[]>>;
  setLicenses: Dispatch<SetStateAction<LocationLicensesDto[]>>;
}

export default function ModuleList({
  modules,
  setSelectedModule,
  setLicenses,
}: Props) {
  const handleCheckboxChange = (module: Module, checked: boolean) => {
    setSelectedModule((prev) => {
      if (checked) {
        return [...prev, { ...module }];
      } else {
        setLicenses((prevLicenses) =>
          prevLicenses.filter((License) => License.moduleId !== module.id),
        );
        return prev.filter((m) => m.id !== module.id);
      }
    });
  };

  if (modules && modules.length > 0) {
    return modules.map((m) => (
      <div className="col-span-1 flex flex-col justify-center" key={m.id}>
        <div className="flex flex-row py-[10px]">
          <Label title={m.name}>
            <input
              type="checkbox"
              value={m.id}
              className="checkbox checkbox-md"
              onChange={(e) => handleCheckboxChange(m, e.target.checked)}
            />
          </Label>
        </div>
      </div>
    ));
  }

  return null;
}
